import { useContext, useEffect } from 'react';

import GoogleAnalyticsContext from './context';
import { GAPageviewData } from './types';
import { LocationContext } from '../LocationProvider';

/**
 * This hook is meant to be used on all screen components, it sends pageview event upon mounting the component. It
 * ignores any further changes of the pageviewData. If you need to send pageview during the page mount, use lower level
 * `useGoogleAnalytics` hook.
 */
const usePageview = (pageviewData: GAPageviewData): void => {
	const { previousLocation } = useContext(LocationContext) || {};

	const googleAnalyticsContext = useContext(GoogleAnalyticsContext);

	useEffect(() => {
		googleAnalyticsContext.sendPageview(pageviewData, previousLocation);
	}, []);
};

export default usePageview;
